@if (displayed) {
  <div class="loader">
    <div class="loader__bar"></div>
  </div>
}
